import PropTypes from 'prop-types';
import DeltaShape from './DeltaShape';
import ReactionShape from './ReactionShape';
import UserShape from './UserShape';

const CommentThreadShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  // Using CommentShape here will cause circular dependency
  comments: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string.isRequired }),
  ),
  context: DeltaShape,
  reactions: PropTypes.arrayOf(ReactionShape),
  post: PropTypes.shape({ id: PropTypes.string }),
  resolvedAt: PropTypes.string,
  resolver: UserShape,
});

export default CommentThreadShape;
